import React, { useState } from "react";
import { Modal, Form, Input, Row, Col, Spin, Button, message } from "antd";
import { api } from "../../Requests/Api";
import { useTranslation } from "react-i18next";
function NewCustomerForm({ visible, optIntModalCb }) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    function handleModalOk() {
        setIsLoading(true);
        form.validateFields()
            .then((val) => {
                val.countryCode = "+" + val.countryCode;
                api.customer()
                    .createOptIn(val)
                    .then((res) => {
                        setIsLoading(false);
                        message.success(t("clientForm.whatsappOptInSuccess"));
                        form.resetFields();
                        optIntModalCb(false);
                    })
                    .catch((err) => {
                        setIsLoading(false);
                        if (err.response?.data?.error?.key === "INVALID_WHATSAPP_NUMBER") {
                            message.error(t("clientForm.whatsappOptInError"));
                        } else if (err.response?.data?.error?.key === "BAD_REQUEST_BODY") {
                            message.error(t("clientForm.whatsappOptInGenericError"));
                        }
                    });
            })
            .catch((err) => {
                setIsLoading(false);
                // Form validation
                console.log(err);
            });
    }
    function closeModal() {
        form.resetFields();
        optIntModalCb(false);
    }
    return (
        <Modal
            title={t("clientForm.customerWhatsappOptIn")}
            open={visible}
            footer={[
                <Button onClick={closeModal}>{t("cancel")}</Button>,
                <Button loading={isLoading} type="primary" onClick={handleModalOk}>
                    {t("Accept")}
                </Button>,
            ]}
            onOk={handleModalOk}
            onCancel={closeModal}
        >
            <Spin spinning={isLoading}>
                <Form form={form} layout="vertical" name="basic">
                    <Form.Item
                        label={t("clientForm.name")}
                        name="name"
                        rules={[{ required: true, message: t("required") }]}
                    >
                        <Input placeholder={t("clientForm.namePlaceholder")} />
                    </Form.Item>
                    <Form.Item
                        label={t("clientForm.email")}
                        name="email"
                        rules={[{ type: "email", message: t("clientForm.invalidEmail") }]}
                    >
                        <Input type="email" placeholder={t("clientForm.emailPlaceholder")} />
                    </Form.Item>
                    <Row gutter="10">
                        <Col flex="150px">
                            <Form.Item
                                label="Code"
                                name="countryCode"
                                rules={[{ required: true, message: t("required") }]}
                            >
                                <Input prefix="+" type="number" placeholder="54" />
                            </Form.Item>
                        </Col>
                        <Col flex="auto">
                            <Form.Item
                                label="Phone"
                                name="phone"
                                rules={[{ required: true, message: t("required") }]}
                            >
                                <Input
                                    type="number"
                                    placeholder={t("clientForm.phonePlaceholder")}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </Modal>
    );
}
export default NewCustomerForm;
